var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kai-splash-screen",class:{completed:!_vm.runningAnimation}},[_c('div',{staticClass:"lottie lottie-isdefault"})])
}
var staticRenderFns = []

export { render, staticRenderFns }